import React, { useEffect, useState } from "react";
import Item from "examples/Item2/Item";
import marie from "assets/images/HR.png";
import { getAdminData } from "Services/AdminServices/HiringService";
import colors from "assets/theme/base/colors";

function EmployeeNameHeader() {
  const [recruiter, setRecruiter] = useState("");
  const userId = localStorage.getItem("userId");
  const savedRoles = localStorage.getItem("role");
  let roles = "";

  try {
    if (savedRoles && savedRoles !== "undefined") {
      roles = savedRoles;
    }
  } catch (err) {
    console.error("Invalid JSON in userRoles:", err);
    roles = "";
  }

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;
      
      const response = await getAdminData(userId);
    
      if (response) {
        const fullName =
          response.firstName && response.lastName
            ? `${response.firstName} ${response.lastName}`
            : response.userName;
        setRecruiter(fullName);
      }
    };
    fetchUserData();
  }, [userId]);

  return (
    <div
      className="admin-header-container"
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: colors.primary.main, // Matches Sidenav active green
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // Soft professional shadow
        position: "relative",
      }}
    >
      <Item
        image={
          <img
            src={marie}
            alt="person"
            style={{
              height: "55px",
              width: "55px",
              borderRadius: "100px",
              border: `2px solid ${colors.light.main}`, // Glowing light green ring
              objectFit: "cover"
            }}
          />
        }
        title={
          <span style={{ color: colors.white.main, fontWeight: "600", fontSize: "1.1rem" }}>
            {recruiter || "Admin User"}
          </span>
        }
        date={
          <span style={{ color: colors.light.main, opacity: 0.9, fontSize: "0.85rem" }}>
            {roles || "Administrator"}
          </span>
        }
      />
    </div>
  );
}

export default EmployeeNameHeader;